import CaptchaData from "../../dto/Captcha/CaptchaData";
import GetUrlPrefix from "../../util/GetUrlPrefix";
import ICaptchaService from "./ICaptchaService";

export default class WebCaptchaService implements ICaptchaService {
    public async getCaptchaData(): Promise<CaptchaData> {
        let resp = await fetch(`${GetUrlPrefix()}api/captcha`, {
            method: "GET", 
            headers: {
                "Accept": "application/json"
            }
        });
        if(!resp.ok) {
            throw new Error("Error loading captcha data");
        }
        let captchaData = (await resp.json()) as CaptchaData;
        return captchaData;
    }
}